module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-700-latin15.c0aa69c.woff2";